// extracted by mini-css-extract-plugin
module.exports = {"container":"DiscountDisclaimerView_container__g4Rky","item":"DiscountDisclaimerView_item__7j38v"};